/**
 * Safe browser utilities for SSR compatibility
 */

/**
 * Get the current pathname safely (works in both SSR and client)
 * @returns {string} The current pathname or empty string if not available
 */
export const getPathname = () => {
  if (typeof window !== "undefined") {
    return window.location.pathname;
  }
  return "";
};

/**
 * Get the current href safely (works in both SSR and client)
 * @returns {string} The current href or empty string if not available
 */
export const getHref = () => {
  if (typeof window !== "undefined") {
    return window.location.href;
  }
  return "";
};

/**
 * Check if code is running in browser
 * @returns {boolean}
 */
export const isBrowser = () => typeof window !== "undefined";